// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/log-in-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,800,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.5 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Roboto; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-\\[0px\\]{
  bottom: 0px;
}
.bottom-\\[180px\\]{
  bottom: 180px;
}
.left-0{
  left: 0px;
}
.left-3{
  left: 0.75rem;
}
.left-\\[0px\\]{
  left: 0px;
}
.right-0{
  right: 0px;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[0px\\]{
  right: 0px;
}
.top-0{
  top: 0px;
}
.top-10{
  top: 2.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-\\[0px\\]{
  top: 0px;
}
.z-10{
  z-index: 10;
}
.z-50{
  z-index: 50;
}
.z-\\[99999\\]{
  z-index: 99999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-full{
  grid-column: 1 / -1;
}
.\\!m-0{
  margin: 0px !important;
}
.m-0{
  margin: 0px;
}
.m-4{
  margin: 1rem;
}
.\\!mx-0{
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.\\!my-0{
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.\\!mb-0{
  margin-bottom: 0px !important;
}
.\\!mb-1{
  margin-bottom: 0.25rem !important;
}
.\\!mb-2{
  margin-bottom: 0.5rem !important;
}
.\\!mb-3{
  margin-bottom: 0.75rem !important;
}
.\\!mb-4{
  margin-bottom: 1rem !important;
}
.\\!ml-9{
  margin-left: 2.25rem !important;
}
.\\!mt-4{
  margin-top: 1rem !important;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-20{
  margin-left: 5rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-9{
  margin-left: 2.25rem;
}
.ml-\\[20px\\]{
  margin-left: 20px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-\\[1rem\\]{
  margin-right: 1rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[0\\.5rem\\]{
  margin-top: 0.5rem;
}
.mt-\\[1rem\\]{
  margin-top: 1rem;
}
.mt-\\[3rem\\]{
  margin-top: 3rem;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline{
  display: inline;
}
.\\!flex{
  display: flex !important;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.grid{
  display: grid;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.\\!h-20{
  height: 5rem !important;
}
.\\!h-\\[2\\.5rem\\]{
  height: 2.5rem !important;
}
.h-10{
  height: 2.5rem;
}
.h-20{
  height: 5rem;
}
.h-60{
  height: 15rem;
}
.h-\\[100\\%\\]{
  height: 100%;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[10rem\\]{
  height: 10rem;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[170px\\]{
  height: 170px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[210px\\]{
  height: 210px;
}
.h-\\[3rem\\]{
  height: 3rem;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[4rem\\]{
  height: 4rem;
}
.h-\\[6rem\\]{
  height: 6rem;
}
.h-\\[75vh\\]{
  height: 75vh;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-\\[10rem\\]{
  max-height: 10rem;
}
.min-h-\\[22rem\\]{
  min-height: 22rem;
}
.min-h-\\[70vh\\]{
  min-height: 70vh;
}
.min-h-\\[75vh\\]{
  min-height: 75vh;
}
.min-h-\\[7rem\\]{
  min-height: 7rem;
}
.\\!w-20{
  width: 5rem !important;
}
.\\!w-24{
  width: 6rem !important;
}
.\\!w-36{
  width: 9rem !important;
}
.\\!w-72{
  width: 18rem !important;
}
.\\!w-80{
  width: 20rem !important;
}
.\\!w-\\[2\\.5rem\\]{
  width: 2.5rem !important;
}
.\\!w-\\[36\\%\\]{
  width: 36% !important;
}
.\\!w-\\[40rem\\]{
  width: 40rem !important;
}
.\\!w-\\[98\\%\\]{
  width: 98% !important;
}
.\\!w-fit{
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-1\\/2{
  width: 50%;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2\\/12{
  width: 16.666667%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3\\/12{
  width: 25%;
}
.w-3\\/4{
  width: 75%;
}
.w-4\\/12{
  width: 33.333333%;
}
.w-5{
  width: 1.25rem;
}
.w-6\\/12{
  width: 50%;
}
.w-7\\/12{
  width: 58.333333%;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[0\\.8rem\\]{
  width: 0.8rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[222px\\]{
  width: 222px;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[36\\%\\]{
  width: 36%;
}
.w-\\[37\\.2\\%\\]{
  width: 37.2%;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[49\\%\\]{
  width: 49%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[148px\\]{
  min-width: 148px;
}
.min-w-\\[18rem\\]{
  min-width: 18rem;
}
.min-w-\\[20rem\\]{
  min-width: 20rem;
}
.min-w-\\[5rem\\]{
  min-width: 5rem;
}
.max-w-\\[2\\.5rem\\]{
  max-width: 2.5rem;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.\\!flex-1{
  flex: 1 1 !important;
}
.flex-1{
  flex: 1 1;
}
.grow{
  flex-grow: 1;
}
.basis-\\[60\\%\\]{
  flex-basis: 60%;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes toast{

  0%{
    transform: translateY(100%);
  }

  100%{
    transform: translateY(0%);
  }
}
.animate-\\[toast_0\\.2s_ease-out_1\\]{
  animation: toast 0.2s ease-out 1;
}
@keyframes categoryEditButton{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}
.animate-categoryEditButton{
  animation: categoryEditButton 0.15s ease-out;
}
.\\!cursor-pointer{
  cursor: pointer !important;
}
.cursor-pointer{
  cursor: pointer;
}
.resize{
  resize: both;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[100\\%\\]{
  grid-template-columns: 100%;
}
.grid-cols-\\[10rem_10rem\\]{
  grid-template-columns: 10rem 10rem;
}
.grid-cols-\\[repeat\\(auto-fill\\2c _minmax\\(200px\\2c _1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-20{
  gap: 5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-9{
  gap: 2.25rem;
}
.gap-\\[1rem\\]{
  gap: 1rem;
}
.gap-\\[8\\.3px\\]{
  gap: 8.3px;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-0{
  row-gap: 0px;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded-\\[2px\\]{
  border-radius: 2px !important;
}
.\\!rounded-lg{
  border-radius: 0.5rem !important;
}
.\\!rounded-md{
  border-radius: 0.375rem !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[50\\%\\]{
  border-radius: 50%;
}
.rounded-\\[8\\.6333px\\]{
  border-radius: 8.6333px;
}
.rounded-\\[8\\.633px\\]{
  border-radius: 8.633px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.\\!border-0{
  border-width: 0px !important;
}
.\\!border-2{
  border-width: 2px !important;
}
.\\!border-\\[1px\\]{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-\\[1\\.5px\\]{
  border-left-width: 1.5px;
}
.\\!border-dashed{
  border-style: dashed !important;
}
.\\!border-none{
  border-style: none !important;
}
.\\!border-\\[\\#00A0B0\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 160 176 / var(--tw-border-opacity)) !important;
}
.\\!border-\\[\\#D9D9D9\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity)) !important;
}
.\\!border-blue-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#00A0B0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 160 176 / var(--tw-border-opacity));
}
.border-\\[\\#00B0C2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(0 176 194 / var(--tw-border-opacity));
}
.border-\\[\\#D0D7E2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(208 215 226 / var(--tw-border-opacity));
}
.border-\\[\\#D9D9D9\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}
.border-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]{
  border-color: rgba(0,0,0,0.3);
}
.border-gray-50\\/40{
  border-color: rgb(249 250 251 / 0.4);
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(0 160 176 / var(--tw-border-opacity));
}
.border-stone-300{
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
.border-b-gray-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-b-slate-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#00A0B0\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 160 176 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#00B0C2\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 176 194 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.\\!bg-\\[rgb\\(244\\2c 247\\2c 251\\)\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 247 251 / var(--tw-bg-opacity)) !important;
}
.\\!bg-inherit{
  background-color: inherit !important;
}
.bg-\\[\\#008A97\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 138 151 / var(--tw-bg-opacity));
}
.bg-\\[\\#00A0B0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 160 176 / var(--tw-bg-opacity));
}
.bg-\\[\\#00B0C2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 176 194 / var(--tw-bg-opacity));
}
.bg-\\[\\#1890ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 144 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#2ECC71\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 204 113 / var(--tw-bg-opacity));
}
.bg-\\[\\#C63617\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(198 54 23 / var(--tw-bg-opacity));
}
.bg-\\[\\#D32F2F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(211 47 47 / var(--tw-bg-opacity));
}
.bg-\\[\\#E74C3C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(231 76 60 / var(--tw-bg-opacity));
}
.bg-\\[\\#F1FEFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 254 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#F2FFF8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 255 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8FAFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#FAFAFA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFC107\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFCF3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 243 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#bfbfbf\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(191 191 191 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f5f5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffffff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(0 160 176 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/\\[0\\.3\\]{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-\\[url\\(\\/public\\/log-in-bg\\.svg\\)\\]{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.object-cover{
  object-fit: cover;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-4{
  padding: 1rem !important;
}
.\\!p-6{
  padding: 1.5rem !important;
}
.\\!p-\\[8px_12px\\]{
  padding: 8px 12px !important;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[10px\\]{
  padding: 10px;
}
.p-\\[2px_5px\\]{
  padding: 2px 5px;
}
.p-\\[33px\\]{
  padding: 33px;
}
.p-\\[8px_12px\\]{
  padding: 8px 12px;
}
.\\!px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.\\!pl-0{
  padding-left: 0px !important;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[\\"Tahoma\\"\\]{
  font-family: "Tahoma";
}
.\\!text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[1\\.4rem\\]{
  font-size: 1.4rem;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\]{
  font-weight: 400;
}
.font-\\[600\\]{
  font-weight: 600;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.leading-none{
  line-height: 1;
}
.\\!text-\\[\\#00A0B0\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(0 160 176 / var(--tw-text-opacity)) !important;
}
.\\!text-\\[\\#00B0C2\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(0 176 194 / var(--tw-text-opacity)) !important;
}
.\\!text-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\]{
  color: rgba(0,0,0,0.3) !important;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-current{
  color: currentColor !important;
}
.\\!text-red-500{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#000000\\]{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#00A0B0\\]{
  --tw-text-opacity: 1;
  color: rgb(0 160 176 / var(--tw-text-opacity));
}
.text-\\[\\#00B0C2\\]{
  --tw-text-opacity: 1;
  color: rgb(0 176 194 / var(--tw-text-opacity));
}
.text-\\[\\#0E9E49\\]{
  --tw-text-opacity: 1;
  color: rgb(14 158 73 / var(--tw-text-opacity));
}
.text-\\[\\#1A63F4\\]{
  --tw-text-opacity: 1;
  color: rgb(26 99 244 / var(--tw-text-opacity));
}
.text-\\[\\#374253\\]{
  --tw-text-opacity: 1;
  color: rgb(55 66 83 / var(--tw-text-opacity));
}
.text-\\[\\#596579\\]{
  --tw-text-opacity: 1;
  color: rgb(89 101 121 / var(--tw-text-opacity));
}
.text-\\[\\#FF6F00\\]{
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-50{
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-light_text{
  --tw-text-opacity: 1;
  color: rgb(89 101 121 / var(--tw-text-opacity));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(0 160 176 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-text{
  --tw-text-opacity: 1;
  color: rgb(28 42 58 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.accent-blue-500{
  accent-color: #3b82f6;
}
.\\!shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0px_2\\.46px_12\\.33px_rgba\\(135\\2c 135\\2c 135\\2c 0\\.13\\)\\]{
  --tw-shadow: 0px 2.46px 12.33px rgba(135,135,135,0.13);
  --tw-shadow-colored: 0px 2.46px 12.33px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0px 4px 11px rgba(143, 143, 143, 0.13);
  --tw-shadow-colored: 0px 4px 11px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline-\\[\\#00A0B0\\]{
  outline-color: #00A0B0;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/*lato font*/

body {
  font-family: Lato, sans-serif !important;
}

.header{
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 160 176 / var(--tw-bg-opacity)) !important;
}
.ant-menu-item-selected{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 247 251 / var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(0 160 176 / var(--tw-text-opacity)) !important;
}

.ant-switch-inner {
  position: relative;
  bottom: 2px;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

.ant-image-preview-img {
  height: 80%;
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

[data-theme="compact"] .site-navigation-steps,
.site-navigation-steps {
  box-shadow: 0px -1px 0 0 #e8e8e8 inset !important;
}

svg {
  vertical-align: baseline !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.ant-table.ant-table-small {
  font-size: 13px !important;
}

.ant-table.ant-table-small .ant-table-footer,
.ant-table.ant-table-small .ant-table-tbody > tr > td,
.ant-table.ant-table-small .ant-table-thead > tr > th,
.ant-table.ant-table-small .ant-table-title,
.ant-table.ant-table-small tfoot > tr > td,
.ant-table.ant-table-small tfoot > tr > th {
  padding: 4px !important;
}

.ant-select-item-option-content {
  white-space: normal !important;
  height: auto !important;
}

#dropdown .ant-select-selection-search {
  left: 0px !important;
}

#dropdown .ant-select-dropdown {
  top: unset !important;
  bottom: 0 !important;
}

#dropdown .ant-select-selector {
  padding: 0 !important;
  line-height: 0;
}

.ant-table-bordered .ant-table-cell,
.ant-table-bordered .ant-table-thead > tr > th,
#order-table .ant-table-bordered .ant-table-thead > tr > th {
  padding-block: 10px !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.ant-table.ant-table-bordered > .ant-table-container {
  border-color: rgba(0, 0, 0, 0.1) !important;
}

.ant-table-bordered .ant-table-tbody tr:last-child .ant-table-cell,
#order-table .ant-table-bordered .ant-table-cell {
  padding-block: 5px !important;
}

#order-table
  .ant-table-bordered
  .ant-table-tbody
  tr:last-child
  .ant-table-cell {
  padding-block: 3px !important;
}

.ant-table-bordered .ant-table-cell:last-child {
  padding: 0 !important;
}

.description-table
  .ant-table-bordered
  .ant-table-tbody
  tr:last-child
  .ant-table-cell {
  padding-block: 10px !important;
}

.placeholder\\:text-\\[\\#D9D9D9\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}

.hover\\:scale-\\[1\\.03\\]:hover{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#008A97\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 138 151 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#0091a1\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 145 161 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#00A0B0\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 160 176 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#118a95\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 138 149 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#12919f\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(18 145 159 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#a31818\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(163 24 24 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#ad2f13\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(173 47 19 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#d39f01\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(211 159 1 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#e8e8e8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(232 232 232 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#effdff\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 253 255 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-white\\/\\[0\\.1\\]:hover{
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/\\[0\\.5\\]:hover{
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:text-\\[\\#ffffff\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:shadow-\\[0px_2\\.46px_12\\.33px_rgba\\(135\\2c 135\\2c 135\\2c 0\\.33\\)\\]:hover{
  --tw-shadow: 0px 2.46px 12.33px rgba(135,135,135,0.33);
  --tw-shadow-colored: 0px 2.46px 12.33px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-0:focus{
  border-width: 0px;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media (min-width: 640px){

  .sm\\:absolute{
    position: absolute;
  }

  .sm\\:top-20{
    top: 5rem;
  }

  .sm\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:mr-3{
    margin-right: 0.75rem;
  }

  .sm\\:\\!block{
    display: block !important;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:\\!hidden{
    display: none !important;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:\\!h-\\[2\\.7rem\\]{
    height: 2.7rem !important;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:\\!w-96{
    width: 24rem !important;
  }

  .sm\\:\\!w-\\[2\\.7rem\\]{
    width: 2.7rem !important;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-\\[18rem\\]{
    width: 18rem;
  }

  .sm\\:w-\\[300px\\]{
    width: 300px;
  }

  .sm\\:w-\\[50\\%\\]{
    width: 50%;
  }

  .sm\\:w-fit{
    width: -moz-fit-content;
    width: fit-content;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:basis-\\[10\\%\\]{
    flex-basis: 10%;
  }

  .sm\\:basis-\\[35\\%\\]{
    flex-basis: 35%;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:gap-0{
    gap: 0px;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-5{
    gap: 1.25rem;
  }

  .sm\\:\\!px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  .sm\\:\\!px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .sm\\:\\!py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .sm\\:px-\\[24px\\]{
    padding-left: 24px;
    padding-right: 24px;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pb-\\[24px\\]{
    padding-bottom: 24px;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }
}

@media (min-width: 768px){

  .md\\:block{
    display: block;
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sDAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,YAAY;;AAEZ;EACE,wCAAwC;AAC1C;;AAGE;EAAA,wBAA8D;EAA9D,8BAA8D;EAA9D,yCAA8D;EAA9D,6BAA8D;EAA9D;AAA8D;AAG9D;EAAA,6BAA6C;EAA7C,oEAA6C;EAA7C,+BAA6C;EAA7C;AAA6C;;AAG/C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAvHA;EAAA,oBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,sBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,kBAwHA;EAxHA;AAwHA;;AAxHA;EAAA;AAwHA;;AAxHA;EAAA;AAwHA;;AAxHA;EAAA,oBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,oBAwHA;EAxHA;AAwHA;;AAxHA;EAAA,oBAwHA;EAxHA;AAwHA;;AAxHA;EAAA;AAwHA;;AAxHA;EAAA,sDAwHA;EAxHA,8DAwHA;EAxHA;AAwHA;;AAxHA;EAAA;AAwHA;;AAxHA;EAAA,8BAwHA;EAxHA;AAwHA;;AAxHA;;EAAA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA,iBAwHA;IAxHA;EAwHA;;EAxHA;IAAA,kBAwHA;IAxHA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA,uBAwHA;IAxHA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA,gCAwHA;IAxHA;EAwHA;;EAxHA;IAAA,+BAwHA;IAxHA;EAwHA;;EAxHA;IAAA,8BAwHA;IAxHA;EAwHA;;EAxHA;IAAA,kBAwHA;IAxHA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;AAAA;;AAxHA;;EAAA;IAAA;EAwHA;;EAxHA;IAAA;EAwHA;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,800,900&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/*lato font*/\n\nbody {\n  font-family: Lato, sans-serif !important;\n}\n\n.header {\n  @apply bg-primary flex items-center justify-between !important;\n}\n.ant-menu-item-selected {\n  @apply bg-[#F4F7FB] text-[#00A0B0] !important;\n}\n\n.ant-switch-inner {\n  position: relative;\n  bottom: 2px;\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n}\n\n.ant-image-preview-img {\n  height: 80%;\n  position: absolute;\n  margin: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n[data-theme=\"compact\"] .site-navigation-steps,\n.site-navigation-steps {\n  box-shadow: 0px -1px 0 0 #e8e8e8 inset !important;\n}\n\nsvg {\n  vertical-align: baseline !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.ant-table.ant-table-small {\n  font-size: 13px !important;\n}\n\n.ant-table.ant-table-small .ant-table-footer,\n.ant-table.ant-table-small .ant-table-tbody > tr > td,\n.ant-table.ant-table-small .ant-table-thead > tr > th,\n.ant-table.ant-table-small .ant-table-title,\n.ant-table.ant-table-small tfoot > tr > td,\n.ant-table.ant-table-small tfoot > tr > th {\n  padding: 4px !important;\n}\n\n.ant-select-item-option-content {\n  white-space: normal !important;\n  height: auto !important;\n}\n\n#dropdown .ant-select-selection-search {\n  left: 0px !important;\n}\n\n#dropdown .ant-select-dropdown {\n  top: unset !important;\n  bottom: 0 !important;\n}\n\n#dropdown .ant-select-selector {\n  padding: 0 !important;\n  line-height: 0;\n}\n\n.ant-table-bordered .ant-table-cell,\n.ant-table-bordered .ant-table-thead > tr > th,\n#order-table .ant-table-bordered .ant-table-thead > tr > th {\n  padding-block: 10px !important;\n  border-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.ant-table.ant-table-bordered > .ant-table-container {\n  border-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.ant-table-bordered .ant-table-tbody tr:last-child .ant-table-cell,\n#order-table .ant-table-bordered .ant-table-cell {\n  padding-block: 5px !important;\n}\n\n#order-table\n  .ant-table-bordered\n  .ant-table-tbody\n  tr:last-child\n  .ant-table-cell {\n  padding-block: 3px !important;\n}\n\n.ant-table-bordered .ant-table-cell:last-child {\n  padding: 0 !important;\n}\n\n.description-table\n  .ant-table-bordered\n  .ant-table-tbody\n  tr:last-child\n  .ant-table-cell {\n  padding-block: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
